import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getOwnPartnerOffices } from '../State/selectors/partners.selectors';
import { PartnerOfficeEntity } from '../entities/partnerOffice.entity';

@Injectable({
  providedIn: 'root'
})
export class PartnerOfficeService {
    private store = inject(Store<State>);

    constructor() { }

    selectOptions$(): Observable<PartnerOfficeEntity[]> {
        return this.store.select(getOwnPartnerOffices).pipe(map(offices => offices.sort((a, b) => a.MainOffice === b.MainOffice ? 0 : a.MainOffice ? -1 : 1)));
    }
}
